import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, InputAdornment, Popover, TextField, Tooltip } from '@mui/material';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Config from '../../config';
import { deleteDraftMessage, getDraftMessage, setDraftMessage } from '../../helpers/conversations-draft.helper';
import setToast from '../../helpers/toaster.helper';
import { BaseChannelConversationItem, ChannelConversationStatus, Contact, Group, GroupChatModel, MediaModel, TypeAction } from '../../models/conversations';
import { ScheduleMessageType } from '../../models/conversations/schedule-messages.model';
import { FileTypes, MediaFileType, MediaType, MessageType } from "../../models/media.models";
import { SettingsModel } from '../../models/settings-model';
import { ChannelTemplates, FacebookTemplateModel, TemplateModel } from '../../models/templates.models';
import { AppState } from '../../reducers/models';
import { SettingsService } from '../../services/SettingsService';
import { UtilityService } from '../../services/UtilityService';
import { AppRoutes } from '../routes/route.path';
import ButtonComponent from '../shared/button/button.component';
import { appNote, AppTags, buttonLabels, Tags, ToasterTexts } from '../shared/constants';
import Audio from "../shared/media/audio.component";
import FileComponent from "../shared/media/file.component";
import ImageComponent from '../shared/media/image.component';
import Video from "../shared/media/video.component";
import Mentions from "../shared/mentions";
import { computeLength, mapTextToDescendants } from '../shared/mentions/models';
import { ToasterType } from '../shared/toaster/toaster.model';
import Emojis from './emojis';
import falkonAiMessageGeneratingLoader from "../shared/loaders/falkon-ai-message-genearating-loader.json";

import {
    DocIcon, WordLargeIcon, XlsLargeIcon, ZipLargeIcon, SearchIconSec, ImgLargeMediaIcon, TxtIcon, MusicIcon, PdfLargeIcon, VideoIcon, SendNewMsgIcon, SendWhiteIcon, EmojiActiveIcon, ComposerSmileIcon, ComposerAttachmentIcon, ComposerSignatureIcon, ComposerTemplateIcon, FileActiveIcon, SignatureActiveIcon, TemplateActiveIcon, CancelIcon, ComposerSendActiveIcon, ComposerSendInActiveIcon,
    LiveChatMediaCancelIcon,
    FalkonAiPurpleIcon,
    FalkonAiWhiteIcon,
    RefineMessageComposerActiveicon,
    RefineMessageComposerDisableicon
} from '../../icon';
import { Dispatch } from '@reduxjs/toolkit';
import CustomTooltip from './CustomTooltip ';
import { ChanneTicketingStatus, ChannelAccountModel, ChannelAccountStatus, ChannelType, Fb24HourWindowTags } from '../../models/channels/channels.model';
import { ChannelConversationService } from '../../services/channels/ChannelConversationService';
import { toNumber } from 'lodash';
import { ChannelPlanModel, ChannelPlanStatus, ChannelUserModel, mapToChannelUser } from '../../models/users.model';
import { ChannelUserService } from '../../services/ChannelUserService';
import ChannelErrorMessageComponent from './channel-error-message-component';
import { ReactTyped } from 'react-typed';
import { ChannelAiService } from '../../services/channels/ChannelAiService';
import AnimateLoaderComponent from '../shared/loaders/animate-loader.component';
import { PlanDetails } from '../../selectors/selectors';
import ImproveMessage from './improve-message.component';

let debounceTimer;
const debounce = (callback, time) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(callback, time);
}

interface IStateProps {
    IsMobileDevice: boolean;
    DeviceHeight: number;
    Templates: TemplateModel[];
    Channels: ChannelAccountModel[];
    FacebookTemplates: FacebookTemplateModel[];
    ChannelTemplates: ChannelTemplates[];
    ActiveChannelsTypes: number[];
    PlanDetails: ChannelPlanModel;
    Aifeatures: boolean;
}

interface IProps extends IStateProps {
    className?: string;
    PhoneNumber?: string;
    PhoneNumbers?: string[];
    Display?: string;
    IsNewMessage?: boolean;
    IsAddRule?: boolean;
    GroupIDs?: string[];
    ContactIDs?: string[];
    HandleClose?: (success?: boolean) => void;
    HandleChange?: (data: { body: string, media: any, bodyLength: number }) => void;
    IsDisabled?: boolean;
    UniqId?: string;
    IsUnsubscribe?: boolean;
    Limit: number;
    UnsubscribedCount?: number;
    BlockedCount?: number;
    style?: any;
    ShowScheduleType?: boolean;
    Message?: string;
    ScheduleType?: number;
    ScheduleDateTime?: number;
    ScheduledMessageID?: string;
    Media?: MediaModel;
    IsAddTemplate?: boolean;
    HandleScheduleTypeChange?: (isScheduleMessage: boolean) => void;
    showSignature?: boolean;
    GroupChat?: GroupChatModel;
    IsGroupChat?: boolean;
    bodySign?: string;
    signLength?: number;
    handleSuccess?: () => void
    setIsMobileSchedule?: (x: boolean) => void
    dispatch: Dispatch;
    TemplateErrorMessage?: any;


    ChannelType?: number;
    ParticipantID?: string;
    SelectedUsers?: BaseChannelConversationItem[];
    SelectedPage?: any;
    SelectedScheduleWindow?: string;
    SelectedTag?: string;
    SelectedScheduleDateTime?: number;
    ChannelAccountID?: string;
    ChannelStatus?: number;
    UserName?: string;
    UserTyping?: boolean;
    TicketingStatus?: ChanneTicketingStatus;
    SuggestionMessage?: string;
}

interface IState {
    SelectedScheduleType: number;
    show: boolean;
    cancel: boolean;
    isTemplate: boolean;
    body: string;
    errorText: string;
    bodyLength: number;
    media: any;
    mediaId: string;
    mediatype: string;
    mediaUrl: string;
    mediaName: string;
    emoji: string;
    openTags: boolean;
    anchorEl: null;
    [x: number]: any;
    showScheduleType: boolean;
    ScheduleDateTime: number;
    sendingNewMessage: boolean;
    showTemplates: boolean;
    searchInput: string;
    anchorTemplate: Element | null;
    ShowMoreOptions: boolean;
    bodySign: string;
    defaultSign: string;
    showSign?: boolean;
    signLength: number;
    ShowBottomDrawer: boolean;
    anchorSecureFile: Element | null;
    onEmojiHover: boolean;
    onFileHove: boolean;
    onTagsHover: boolean;
    onTemplateHover: boolean;
    onSecureFileHover: boolean;
    onSignatureHover: boolean;
    showCalnder: boolean;
    anchorEmjoi: Element | null;
    onScheduleHover: boolean;
    selectedFbTag: string;
    facebookTemplate: any;
    aiFeaturesPopUp: boolean;
    falkonAiMessageRefineFeatures: { Name: string, Active: boolean, type: string }[];
    messageTone: string;
    messageImprove: boolean;
    language: string;
    falkonAiMessage: string;
    aiAnimation: boolean;
}

class MessageComposer extends Component<IProps, IState> {
    recentTypingEvent: TypeAction = TypeAction.STOP_TYPING;
    constructor(props: IProps) {
        super(props);
        const draftedMessage = getDraftMessage(this.props.ParticipantID || "");
        const message = this.props.Message ? this.props.Message : (this.props.PhoneNumbers || this.props.GroupChat?.PhoneNumbers) ? draftedMessage : "";
        this.state = {
            show: false,
            isTemplate: false,
            cancel: false,
            body: message,
            errorText: "",
            bodyLength: computeLength(mapTextToDescendants(message, AppTags, false)),
            media: !!this.props.Media?.Url ? this.props.Media : "",
            mediaId: this.props.Media?.ID || "",
            mediatype: this.props.Media?.ContentType || "",
            mediaUrl: this.props.Media?.Url || "",
            mediaName: this.props.Media?.Name || "",
            emoji: "",
            anchorEl: null,
            SelectedScheduleType: this.props.ScheduleType === undefined ? 0 : this.props.ScheduleType,
            showScheduleType: this.props.ShowScheduleType ? this.props.ShowScheduleType : false,
            ScheduleDateTime: (this.props.ScheduleDateTime !== -1 && this.props.ScheduleDateTime) ? UtilityService.convertToPreferredTimeZone(this.props.ScheduleDateTime).getTime() : -1,
            sendingNewMessage: false,
            openTags: false, showTemplates: false, searchInput: '', anchorTemplate: null,
            ShowMoreOptions: false,
            bodySign: this.props.bodySign, defaultSign: "", signLength: this.props.signLength,
            ShowBottomDrawer: false,
            showSign: this.props.showSignature,
            anchorSecureFile: null,
            onEmojiHover: false,
            onFileHove: false,
            onTagsHover: false,
            onTemplateHover: false,
            onSecureFileHover: false,
            onSignatureHover: false,
            showCalnder: false,
            anchorEmjoi: null,
            onScheduleHover: false,
            selectedFbTag: "",
            facebookTemplate: "",
            aiFeaturesPopUp: false,
            falkonAiMessageRefineFeatures: [
                { Name: "Shorten", Active: false, type: "length" },
                { Name: "Expand", Active: false, type: "length" },
            ],
            messageImprove: false,
            messageTone: "Formal",
            language: "English",
            falkonAiMessage: "",
            aiAnimation: false
        }
    }
    CurrentUser = ChannelUserService.getCurrentUserFromLocalStorage();

    tagRef = React.createRef<HTMLButtonElement>();
    templateRef = React.createRef<HTMLButtonElement>();
    secureFileRef = React.createRef<HTMLButtonElement>();
    emojiRef = React.createRef<HTMLButtonElement>();
    emojiRefInAi = React.createRef<HTMLButtonElement>();
    calenderRef = React.createRef<HTMLDivElement>();
    AiFeaturesRef = React.createRef<HTMLDivElement>();

    onClickshowTemplates = (event: any) => {
        this.setState({ anchorEl: event.currentTarget });
    }

    onBodyChange = (event: any) => {
        this.setState({ isTemplate: false });
        this.updateBody(event.target.value.replace(/[\u200B-\u200D\uFEFF]/g, ''));
    };

    onSignatureChange = (event: any, length: number) => {
        this.updateSignature(event.target.value, length)
    };

    updateSignature = (signature: string, length: number) => {
        var text = signature
        this.setState({
            bodySign: text,
            signLength: length + 2,
        })
    }

    updateBody = (message: string) => {
        this.setState({ body: message });
        var text = message;

        var bodyLength = computeLength(mapTextToDescendants(text, AppTags, false))
        setDraftMessage(this.props.ParticipantID, text)
        this.setState({
            body: text,
            bodyLength
        }, () => {
            if (this.props.HandleChange) {
                this.props.HandleChange({
                    body: this.getMessageBody(),
                    media: (this.props.IsAddTemplate || this.props.IsAddRule) && this.state.media,
                    bodyLength: this.getMessageLength()
                });
            }
        });

        if (this.recentTypingEvent === TypeAction.STOP_TYPING && !this.props.IsAddTemplate && !this.props.IsAddRule && message.length) {
            this.recentTypingEvent = TypeAction.START_TYPING;
            ChannelConversationService.IsTyping(this.props.ParticipantID, { user_typing: this.props.UserTyping, business_typing: true, user_name: ChannelUserService.getCurrentUserFromLocalStorage()?.FullName }).then(res => {
            }).catch(() => {
            })
        }

    }

    handleClick = (event: any) => {
        this.setState({ anchorEl: event.currentTarget })
    };

    handleClose = () => {
        this.setState({ anchorEl: null })
    };

    openTemplates = (event: any) => {
        this.setState({ anchorTemplate: this.templateRef.current })
    };

    onCloseshowTemplates = () => {
        this.setState({ anchorTemplate: null, searchInput: "" });
    };

    searchTemplates = (e: any) => {
        this.setState({ searchInput: e.target.value })
    }

    trimMessage = (message: string, chars: number) => {
        let shortMessage = message.slice(0, chars);
        let index = (shortMessage.lastIndexOf("{{") || shortMessage.lastIndexOf("{") || shortMessage.lastIndexOf("{{_"))
        let indexPosition = (index === 0 || index === -1) ? 0 : index
        let patternFirst = (shortMessage.match(/{{_/g) || []).length
        let patternLast = (shortMessage.match(/_}}/g) || []).length
        let string = shortMessage.slice(0, indexPosition)
        let stringIndex = indexPosition === 0 ? shortMessage : string
        let finalString = patternFirst !== patternLast ? stringIndex : shortMessage;
        return !!message ? finalString + (message.length > chars ? "..." : "") : "";
    }

    handleTemplateClick = (data: TemplateModel) => {
        this.updateBody(data.Message);
        this.setState({
            mediaId: data.Media?.ID || "",
            mediatype: data.Media?.ContentType || "",
            mediaUrl: data.Media?.Url || "",
            mediaName: data.Media?.Name || "",
            isTemplate: true,
        })
    }

    getMessageBody = () => this.state.body + (!this.props.IsAddRule && !this.props.IsAddTemplate && this.state.showSign ? '\r\n' + (this.state.bodySign || this.state.defaultSign) : "")
    getMessageBodyWithoutSign = () => this.state.body;
    getMessageLength = () => this.state.bodyLength + (!this.props.IsAddRule && !this.props.IsAddTemplate && this.state.showSign ? this.state.signLength ?? 0 : 0)
    getMessageParts = () => Math.ceil((this.getMessageLength()) / 160)

    handleMediaChange = async (e: any) => {
        let file = e.target.files[0];
        if (file !== undefined) {
            if (file.type === "text/plain") {
                setToast(ToasterTexts.Text_File_Not_Supported, ToasterType.DANGER)
                this.closeMedia();
            }

            else if (file != null && file.size < Config.CHANNEL_FILE_SIZE) {
                e.target.value = "";
                this.setState({ media: file, mediaUrl: await this.toBase64(file), mediatype: file.type.split('/')[0], mediaName: file.name });
                if (this.props.HandleChange) {
                    this.props.HandleChange({
                        body: this.getMessageBody(),
                        media: file,
                        bodyLength: this.getMessageLength()
                    });
                }
            }
            else {
                e.target.value = "";
                setToast(ToasterTexts.FILE_SIZE_EXCEED_LIMIT.replace("<size>", (Config.FILE_SIZE / 1000000).toFixed(0)), ToasterType.DANGER)
                this.handleClose();
            }

        }
    }

    toBase64 = (file: any) => new Promise<any>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    closeMedia = () => {
        this.setState({ media: "", mediaUrl: "", mediatype: "", mediaId: "", mediaName: "" });
        if (this.props.HandleChange) {
            this.props.HandleChange({
                body: this.getMessageBody(),
                media: null,
                bodyLength: this.getMessageLength()
            });
        }
    }

    getComponent = (type: any) => {
        if (type != null) {
            switch (type) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_WEBP:
                    return <ImageComponent MediaUrl={this.state.mediaUrl} classname={"w-5 h-5"} text={true} />
                case MediaType.VIDEO:
                    return <Video MediaUrl={this.state.mediaUrl} controls={false} />
                case MediaType.AUDIO:
                case MediaType.AUDIO_MP3:
                case MediaType.AUDIO_MPeg:
                    return <Audio MediaUrl={this.state.mediaUrl} controls={true} />
                default:
                    return <FileComponent media={{
                        Name: this.state.mediaName,
                        ContentType: this.state.mediatype,
                        Url: this.state.mediaUrl,
                        ID: this.state.mediaId
                    }} onClose={this.closeMedia} cross={true} />
            }
        }
    }

    getTemplateMediaIcon = (type: any) => {
        if (type != null) {
            switch (type) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_WEBP:
                    return <ImgLargeMediaIcon className={"w-3 h-3"} />
                case MediaFileType.PDF:
                case FileTypes.PDF_TYPE:
                    return <PdfLargeIcon className={"w-3 h-3"} />
                case MediaFileType.ZIP:
                case FileTypes.ZIP_TYPE:
                    return <ZipLargeIcon className={"w-3 h-3"} />
                case MediaFileType.DOC:
                case FileTypes.WORD_TYPE:
                    return <WordLargeIcon className={"w-3 h-3"} />
                case MediaFileType.DOCX:
                    return <DocIcon className={"w-3 h-3"} />
                case MediaFileType.XLSX:
                case FileTypes.XLSX_TYPE:
                    return <XlsLargeIcon className={"w-3 h-3"} />
                case MediaFileType.TXT:
                case FileTypes.TEXT_TYPE:
                    return <TxtIcon className={"w-3 h-3"} />
                case MediaType.VIDEO:
                case MediaType.VIDEO_MP4:
                    return <VideoIcon className={"w-3 h-3"} />
                case MediaType.AUDIO:
                case MediaType.AUDIO_MP3:
                case MediaType.AUDIO_MPeg:
                    return <MusicIcon className={"w-3 h-3"} />
                default:
                    return <DocIcon className={"w-3 h-3"} />
            }
        }
    }
    getMediaComponent = (mediatype: string) => {
        if (mediatype != null) {
            switch (mediatype) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_WEBP:
                    return MessageType.IMAGE
                case MediaType.VIDEO:
                    return MessageType.VIDEO
                case MediaType.AUDIO:
                    return MessageType.AUDIO
                default:
                    return MessageType.FILE
            }
        }
    }

    sendMessage = async () => {
        // if (this.getMessageParts() >= 12.5) {
        //     return;
        // }

        if (!this.IsMessageValid()) {
            return;
        }

        const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;
        if (!!this.state.facebookTemplate && this.props.ChannelType === ChannelType.FACEBOOK) {
            let mediaIdFromFb = ""
            await ChannelConversationService.getPhotosFromFacebook(this.props.Channels.find(x => x.ID === this.props.ChannelAccountID)?.AccountId)
                .then(res => {
                    mediaIdFromFb = res.data.data.find(x => x.preview_link === this.state.facebookTemplate.Payload.elements[0].url)?.id

                }).catch((err) => {
                    console.error(err);
                }
                )
            let data = this.state.facebookTemplate?.TemplateType === "button" ?
                { "payload": this.state.facebookTemplate.Payload }
                : {
                    "type": this.state.facebookTemplate?.TemplateType,
                    "name": this.state.facebookTemplate?.Title,
                    "payload": {
                        "template_type": this.state.facebookTemplate?.TemplateType,
                        "title": this.state.facebookTemplate?.Title,
                        "elements": [{
                            "media_type": this.state.facebookTemplate.Payload.elements[0].media_type,
                            "url": mediaIdFromFb,
                            "buttons": this.state.facebookTemplate.Payload?.buttons
                        }],
                    }
                }

            ChannelConversationService.sendFacebookTemplateMessage(this.props.ParticipantID, this.props.ChannelType, data)
                .then(res => {
                    this.setState({ facebookTemplate: "", body: "", bodySign: "", signLength: 0, bodyLength: 0, showSign: this.CurrentUser.Signature.IsEnabledSign });
                })
                .catch(err => {
                    mediaIdFromFb === undefined && setToast("media in the template may have been removed/does not exist in the facebook account", ToasterType.DANGER);
                    this.setState({ facebookTemplate: "", body: "", bodySign: "", signLength: 0, bodyLength: 0, showSign: this.CurrentUser.Signature.IsEnabledSign });
                })
        }
        else if (!this.props?.IsNewMessage) {
            // this.props.HandlePush({
            //     type: Actions.UPDATE_CHANNEL_HISTORY,
            //     payload: ({
            //         channelConversationId: props.ParticipantID, history: [
            //             mapToChannelMessage(
            //                 {
            //                     sender_id: user.ID,
            //                     Message: { value: getMessageBody(props) },
            //                     created_at: new Date().toISOString(),
            //                     inbound: false,
            //                     participant_id: props.ParticipantID,
            //                     is_unread: false,
            //                     status: ChannelDeliveryStatus.SENDING,
            //                 }
            //             )
            //         ], updateLatest: true
            //     })
            // })

            let TagsValue = this.state.selectedFbTag === Fb24HourWindowTags.CONFIRMED_EVENT_UPDATE ? 2 : this.state.selectedFbTag === Fb24HourWindowTags.CUSTOMER_FEEDBACK ? 3 : this.state.selectedFbTag === Fb24HourWindowTags.ACCOUNT_UPDATE ? 4 : this.state.selectedFbTag === Fb24HourWindowTags.HUMAN_AGENT ? 5 : 1

            if (!!this.getMessageBody()) {
                ChannelConversationService.sendChannelTextMessage(this.props.ParticipantID, this.props.ChannelType, TagsValue,
                    {
                        participant_id: this.props.ParticipantID,
                        user_id: user.ID,
                        text: this.getMessageBody(),
                    })
            }
            if (!!this.state.media) {
                var formData = new FormData();
                formData.append("file", this.state.media ? this.state.media : null);
                ChannelConversationService.sendChannelMediaMessage(this.props.ParticipantID, this.getMediaComponent(this.state.mediatype), this.props.ChannelType, user.ID, formData).then((res) => {
                }).catch((res) => {
                    setToast(` ${res.response.data["Upload Error"]}`, ToasterType.DANGER, "default")
                })
            }
            this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0, sendingNewMessage: false, media: "", mediaUrl: "", mediatype: "", mediaId: "", mediaName: "", showSign: this.CurrentUser.Signature.IsEnabledSign });
            // if (this.props.HandleClose) {
            //     this.props.HandleClose();
            // }
            deleteDraftMessage(this.props.ParticipantID)
        }
        else if (!!this.props.SelectedScheduleDateTime) {
            if (!!this.getMessageBody()) {
                ChannelConversationService.sendChannelTextScheduleMessage({ type: 1, channel: this.props.ChannelType, account_id: this.props.SelectedPage.ID, participant_ids: this.props.SelectedUsers.map(x => x.ID), next_send_at: this.props.SelectedScheduleDateTime, tag: this.props.SelectedScheduleWindow === "1" ? 0 : this.props.SelectedTag === Fb24HourWindowTags.CONFIRMED_EVENT_UPDATE ? 1 : this.props.SelectedTag === Fb24HourWindowTags.CUSTOMER_FEEDBACK ? 2 : this.props.SelectedTag === Fb24HourWindowTags.ACCOUNT_UPDATE ? 3 : 4, schedule_window_type: toNumber(this.props.SelectedScheduleWindow), text: { type: "text", value: this.getMessageBody() } })
                    .then(res => {
                        setToast(ToasterTexts.SCHEDULED_MESSAGE_UPDATED_SUCCESS, ToasterType.SUCCESS);
                        setTimeout(() => { !!this.props.handleSuccess && this.props.handleSuccess() }, 500);
                    }).catch(err => { })
            }
            if (!!this.state.media) {
                var formData = new FormData();
                formData.append("file", this.state.media ? this.state.media : null);
                ChannelConversationService.sendChannelMediaScheduleMessage(this.props.SelectedUsers.map(x => x.ID).join(","), this.getMediaComponent(this.state.mediatype), this.props.ChannelType, user.ID, toNumber(this.props.SelectedScheduleWindow), this.props.SelectedScheduleDateTime, this.props.SelectedPage.ID, formData)
                    .then(res => {
                        if (!this.getMessageBody()) {
                            setToast(ToasterTexts.SCHEDULED_MESSAGE_UPDATED_SUCCESS, ToasterType.SUCCESS);
                            setTimeout(() => { !!this.props.handleSuccess && this.props.handleSuccess() }, 500);
                        }
                    }).catch((res) => {
                        setToast(` ${res.response.data["Upload Error"]}`, ToasterType.DANGER, "never")
                    })
            }
            if (this.props?.HandleClose) {
                this.props.HandleClose();
            }
            this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0, sendingNewMessage: false, media: "", mediaUrl: "", mediatype: "", mediaId: "", mediaName: "", showSign: this.CurrentUser.Signature.IsEnabledSign });
        }
        else if (this.props.SelectedUsers.length === 1) {
            let TagsValue = 1
            if (!!this.getMessageBody()) {
                ChannelConversationService.sendChannelTextMessage(this.props.SelectedUsers[0].ID, this.props.SelectedUsers[0].Type as unknown as ChannelType, TagsValue,
                    {
                        participant_id: this.props.SelectedUsers[0]?.ID,
                        user_id: user.ID,
                        text: this.getMessageBody(),
                    })
            }
            if (!!this.state.media) {
                var formData = new FormData();
                formData.append("file", this.state?.media ? this.state?.media : null);
                ChannelConversationService.sendChannelMediaMessage(this.props.SelectedUsers[0].ID, this.getMediaComponent(this.state.mediatype), this.props.SelectedUsers[0].Type as unknown as ChannelType, user.ID, formData)
                    .then((res) => {
                    }).catch((res) => {
                        setToast(` ${res.response.data["Upload Error"]}`, ToasterType.DANGER, 'never')
                    })
            }
            this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0, sendingNewMessage: false, media: "", mediaUrl: "", mediatype: "", mediaId: "", mediaName: "", showSign: this.CurrentUser.Signature.IsEnabledSign });
            if (this.props?.HandleClose) {
                this.props.HandleClose();
            }
        }
        else {
            if (!!this.getMessageBody()) {
                ChannelConversationService.sendChannelBroadcastTextMessage({ channel: this.props.SelectedUsers[0].Type, account_id: this.props.SelectedPage.ID, participant_ids: this.props.SelectedUsers.map(x => x.ID), text: this.getMessageBody() })
            }
            if (!!this.state.media) {
                var formData = new FormData();
                formData.append("file", this.state.media ? this.state.media : null);
                ChannelConversationService.sendChannelBroadcastMultiMediaMessage(this.props.SelectedUsers.map(x => x.ID).join(","), this.getMediaComponent(this.state.mediatype), this.props.SelectedUsers[0].Type as unknown as ChannelType, user.ID, formData).then((res) => {
                }).catch((res) => {
                    setToast(` ${res.response.data["Upload Error"]}`, ToasterType.DANGER, 'never')
                })
            }
            this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0, sendingNewMessage: false, media: "", mediaUrl: "", mediatype: "", mediaId: "", mediaName: "", showSign: this.CurrentUser.Signature.IsEnabledSign });
            if (this.props.HandleClose) {
                this.props.HandleClose();
            }
        }
    };

    componentDidMount() {
        let Sign = this.CurrentUser?.Signature.Value;

        let SignALL = this.CurrentUser?.Signature.IsEnabledSign;
        this.setState({ showSign: SignALL || this.props.showSignature, defaultSign: Sign, signLength: Sign?.length + 2 });
    }

    componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (prevProps.SuggestionMessage !== this.props.SuggestionMessage) {
            this.setState({ body: this.props.SuggestionMessage, bodyLength: this.props.SuggestionMessage.length })
        }
        if (prevProps?.ChannelType !== this.props?.ChannelType) {
            this.setState({ body: "", media: "", mediaId: "", mediaName: "", mediatype: "", mediaUrl: "" })
        }
        if (JSON.stringify(prevProps.ParticipantID) !== JSON.stringify(this.props.ParticipantID) && !this.props.IsNewMessage) {
            let draft = getDraftMessage(this.props.ParticipantID || "");
            let Sign = this.CurrentUser?.Signature.Value;

            let SignALL = this.CurrentUser?.Signature.IsEnabledSign;

            this.setState({
                body: draft,
                bodyLength: draft?.length,
                SelectedScheduleType: 0,
                showScheduleType: false,
                ScheduleDateTime: -1,
                mediaId: "",
                mediatype: "",
                mediaUrl: "",
                mediaName: "",
                media: "",
                defaultSign: Sign ? Sign : "",
                showSign: (SignALL || this.props.showSignature),
                selectedFbTag: ""
            });
            this.sendStopTypingEvent(prevProps.PhoneNumbers[0])
        }
        if ((this.props.Media?.ID !== prevProps.Media?.ID && this.props.Media?.ID) || (this.props.Media?.Url !== prevProps.Media?.Url && this.props.Media?.Url)) {
            this.setState({
                mediaId: this.props.Media?.ID || this.state.mediaId,
                mediatype: this.props.Media?.ContentType || this.state.mediatype,
                mediaUrl: this.props.Media?.Url || this.state.mediaUrl,
                mediaName: this.props.Media?.Name || this.state.mediaName,
                media: !!this.props.Media?.Url ? this.props.Media : this.state.media,
            });
        }
    }

    handleEmojiSelect = (e: any) => {
        this.setState({
            emoji: e.native
        });
        setTimeout(() => {
            this.setState({ emoji: "" });
        }, 100)
        this.setState({ anchorEmjoi: null })
    };

    sendStopTypingEvent = (phoneNumber: string) => {
        if (this.recentTypingEvent === TypeAction.START_TYPING && !this.props.IsNewMessage) {
            this.recentTypingEvent = TypeAction.STOP_TYPING;
            ChannelConversationService.IsTyping(this.props.ParticipantID, { user_typing: this.props.UserTyping, business_typing: false }).then(res => {
            }).catch(() => {
            })
        }
    }

    HandleKeyDown = (event: any) => {
        if (!event.altKey && !event.shiftKey && event.keyCode === 13) {
            this.sendMessage()
            event.preventDefault();
            this.sendStopTypingEvent(this.props.PhoneNumbers[0]);
            return
        }
        if (event.keyCode === 27) {
            this.closeMedia()
            this.setState({ body: "", bodyLength: 0 });
            this.sendStopTypingEvent(this.props.PhoneNumbers[0]);
            return
        }
        if (!this.props.IsAddRule && !this.props.IsAddTemplate) {
            debounce(() => this.sendStopTypingEvent(this.props.PhoneNumbers[0]), 5000)
        }
    }


    IsMessageValid = (): boolean => {

        let messageValid = true;
        messageValid = messageValid && !this.props.IsDisabled;

        let body = this.getMessageBodyWithoutSign();

        body = body.trim();

        let messageLength = (this.state.facebookTemplate || this.props.ChannelType === ChannelType.LIVE_CHAT) ? true : this.getMessageParts() < 12.5;
        messageValid = messageValid && (!!this.state.facebookTemplate || !!body || !!this.state.media || !!this.state.mediaId || !!this.state.mediaName || !!this.state.mediaUrl);
        messageValid = messageValid && messageLength;

        if ((this.props.Channels?.find(x => x.ID === this.props.ChannelAccountID)?.Status === ChannelAccountStatus.DISCONNECTED || this.props.Channels?.find(x => x.ID === this.props.ChannelAccountID)?.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY || this.props.ChannelStatus === ChannelConversationStatus.INACTIVE || this.props.ChannelStatus === ChannelConversationStatus.CONVERSATION_WINDOW_EXPIRED || this.props.TicketingStatus === ChanneTicketingStatus.Closed)) {
            messageValid = messageValid && !!this.state.selectedFbTag
        }
        return messageValid;
    }

    onClickSignature = () => {
        let defaultSign = this.CurrentUser?.Signature.Value;

        this.setState({ showSign: !this.state.showSign, defaultSign, bodySign: this.state.body ? defaultSign : "", signLength: defaultSign?.length + 2, openTags: false })
    }

    HandleBlur = (event: any) => {
        // event?.preventDefault();
        if (!this.props.IsAddRule && !this.props.IsAddTemplate) {
            debounce(() => this.sendStopTypingEvent(this.props.PhoneNumbers[0]), 1000)
        }
    }

    componentWillUnmount(): void {
        if (!this.props.IsAddRule && !this.props.IsAddTemplate) {
            debounce(() => this.sendStopTypingEvent(this.props.PhoneNumbers[0]), 500)
        }
    }

    handleWindowTags = (tagValue) => {
        this.setState({ selectedFbTag: tagValue })
    }

    handleChannelTemplateClick = async (data: any) => {
        if (data.ChannelType === ChannelType.FACEBOOK) {
            this.setState({ facebookTemplate: data })
        }
        else {
            this.updateBody(data.Message);
            this.setState({
                mediaUrl: data.Url || "",
                mediaName: data.Filename || "",
                mediatype: data.MediaType || "",
                isTemplate: true,
            })
            if (data?.Url) {
                let extension = data.Url?.substring(data.Url.lastIndexOf(".") + 1) === "svg" ? "image/svg+xml" : data.MediaType;
                let file = new File([await ((await fetch(data.Url)).blob())], data.Filename, { type: extension });
                this.setState({ media: file as any })
            }
        }
    }

    RemoveFacebookTemplate = () => {
        this.setState({ facebookTemplate: "" })
    }

    handleMessageRefineFeatures = (name, status) => {
        this.setState({ falkonAiMessageRefineFeatures: this.state.falkonAiMessageRefineFeatures.map(x => x.Name === name ? { ...x, Active: !status } : { ...x, Active: false }) })
    }

    handleResetAiFeatureSelection = () => {
        this.setState({
            falkonAiMessageRefineFeatures: [
                { Name: "Shorten", Active: false, type: "length" },
                { Name: "Expand", Active: false, type: "length" },
            ],
            messageTone: "Formal",
            language: "English",
            falkonAiMessage: "",
            messageImprove: false,
            aiAnimation: false
        })
    }

    handleMessageImprovement = () => {
        this.setState({ aiAnimation: true })
        ChannelAiService.getImprovedMessage({
            message: this.state.body,
            improve: this.state.messageImprove,
            length: this.state.falkonAiMessageRefineFeatures.find(x => x.Active)?.Name || "",
            tone: this.state.messageTone,
            channel: this.props.ChannelType
        }).then((res) => {
            this.setState({ falkonAiMessage: res.data.refined_message, aiAnimation: false })
        })
    }

    handleUseFalkonAiMessage = () => {
        this.setState({ body: this.state.falkonAiMessage, bodyLength: this.state.falkonAiMessage.length, aiFeaturesPopUp: false })
    }

    render() {
        const fliterChannelTemplates = (this.props?.ChannelTemplates?.filter((x) =>
            this.state.searchInput
                ? (x.Filename || "")
                    .toLowerCase()
                    .includes(this.state.searchInput.toLowerCase()) ||
                (x.Title || "")
                    .toLowerCase()
                    .includes(this.state.searchInput.toLowerCase()) ||
                (x.Message || "")
                    .toLowerCase()
                    .includes(this.state.searchInput.toLowerCase())
                : true).filter(x => x.ChannelType === this.props.ChannelType).filter(x => x.ChannelType === ChannelType.LIVE_CHAT && x.ChannelAccountID === this.props?.ChannelAccountID))

        const filterFacebookTemplates = (this.props.FacebookTemplates?.filter(x => x.ChannelAccountID === this.props?.ChannelAccountID)
            .filter((x) =>
                this.state.searchInput
                    ? (x.Title || "")
                        .toLowerCase()
                        .includes(this.state.searchInput.toLowerCase())
                    : true))
        return (
            <div className={`d-flex flex-direction ${this.props.IsMobileDevice ? `bg-color-secondary ${this.props.IsNewMessage ? "" : "box-shadow-mobile-composer"}  ` : ""} ${this.props.className} ${(this.props.IsNewMessage || this.props.IsAddRule || this.props.IsAddTemplate) ? "w-fill" : `pt-1 ${this.props.IsMobileDevice ? "" : "px-2 pb-2"}`} `}>
                {
                    this.state.aiFeaturesPopUp &&
                    <ImproveMessage Body={this.state.body} SetBody={(data) => { this.setState({ body: data, bodyLength: data.length }); debounce(() => this.sendStopTypingEvent(this.props.PhoneNumbers[0]), 5000) }} AiFeaturesRef={this.AiFeaturesRef} HandleAIfeaturesPopOver={() => { this.setState({ aiFeaturesPopUp: !this.state.aiFeaturesPopUp }) }} />
                }
                <div className={`d-flex ${this.props.IsNewMessage ? this.props.IsMobileDevice ? "flex-column-reverse " : "flex-column-reverse br-5" : this.props.IsMobileDevice ? "flex-direction" : "flex-direction RichEditor-root-border mx-2 br-5"}`}>
                    {(!this.props.IsNewMessage && (this.props.Channels?.find(x => x.ID === this.props.ChannelAccountID)?.Status === ChannelAccountStatus.DISCONNECTED || this.props.Channels?.find(x => x.ID === this.props.ChannelAccountID)?.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY || this.props.ChannelStatus === ChannelConversationStatus.INACTIVE || this.props.ChannelStatus === ChannelConversationStatus.CONVERSATION_WINDOW_EXPIRED || this.props.TicketingStatus === ChanneTicketingStatus.Closed)) &&
                        <ChannelErrorMessageComponent
                            ChannelType={this.props.ChannelType}
                            ChannelAccountID={this.props.ChannelAccountID}
                            ChannelStatus={this.props.ChannelStatus}
                            SelectedFbTag={this.state.selectedFbTag}
                            HandleWindowTags={this.handleWindowTags}
                            Channels={this.props.Channels}
                            TicketingStatus={this.props.TicketingStatus}
                        />
                    }
                    <div ref={this.AiFeaturesRef} className={`${(this.props.IsMobileDevice && !this.props.IsNewMessage) ? "mx-1" : this.props.IsNewMessage ? "" : "pl-2"}`}>
                        <div className='d-flex justify-between h-5' onMouseLeave={() => { this.setState({ onEmojiHover: false, onTagsHover: false, onSecureFileHover: false, onFileHove: false, onTemplateHover: false, onSignatureHover: false, onScheduleHover: false }) }}>
                            <div className='d-flex  align-center'>
                                {!this.props.IsMobileDevice &&
                                    <CustomTooltip title='Emoji' placement='bottom'>
                                        <div className="my-auto">
                                            <button tabIndex={13} data-up-arrow-index={300} ref={this.emojiRef}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (this.state.anchorEmjoi) {
                                                        this.setState({ anchorEmjoi: null })

                                                    } else {
                                                        this.setState({ anchorEmjoi: this.emojiRef.current })
                                                    }
                                                }}
                                                onMouseEnter={() => { this.setState({ onEmojiHover: true }) }}
                                                onMouseLeave={() => { this.setState({ onEmojiHover: false }) }}
                                            >
                                                {(this.state.onEmojiHover || !!this.state.anchorEmjoi) ? <EmojiActiveIcon className={`c-pointer p-1`} /> : <ComposerSmileIcon className={`c-pointer p-1`} />
                                                }
                                            </button>
                                        </div>
                                    </CustomTooltip >}
                                {<CustomTooltip title='Attach File' placement='bottom'>
                                    <div className="my-auto">
                                        <label onKeyDown={(e) => { if (e.key === "Enter") { e.currentTarget?.click() } }} role="button" data-up-arrow-index={300} tabIndex={14} onClick={this.handleClick} className={``} htmlFor={"Upload" + this.props.UniqId}
                                            onMouseEnter={() => { this.setState({ onFileHove: true }) }}
                                            onMouseLeave={() => { this.setState({ onFileHove: false }) }}
                                        >
                                            {this.state.onFileHove ? <FileActiveIcon className={`c-pointer p-1`} /> : <ComposerAttachmentIcon className={`c-pointer p-1`} />
                                            }
                                        </label>
                                        <input className={"d-none"} id={"Upload" + this.props.UniqId} onChange={this.handleMediaChange}
                                            accept="audio/*,video/*,image/*,.pdf,.doc,.docx,.xlsx,.zip,.txt" multiple type="file" />
                                    </div></CustomTooltip>}
                                {
                                    !this.props.IsAddTemplate && this.props.PlanDetails.FeatureKeys.includes("templates") && (this.props.PlanDetails.Status === ChannelPlanStatus.ACTIVE || this.props.PlanDetails.Status === ChannelPlanStatus.TRAIL) && !this.props.IsAddRule &&
                                    <CustomTooltip title='Templates' placement='bottom'>
                                        <div className="my-auto">
                                            <button ref={this.templateRef} tabIndex={15} data-up-arrow-index={300} onClick={(e) => {
                                                e.preventDefault()
                                                if (Boolean(this.state.anchorTemplate)) {
                                                    this.onCloseshowTemplates()
                                                } else {
                                                    this.openTemplates(e)
                                                }
                                            }}
                                                onMouseEnter={() => { this.setState({ onTemplateHover: true }) }}
                                                onMouseLeave={() => { this.setState({ onTemplateHover: false }) }}
                                            >
                                                {(this.state.onTemplateHover || !!this.state.anchorTemplate) ? <TemplateActiveIcon className={`c-pointer p-1`} /> : <ComposerTemplateIcon className={`c-pointer p-1`} />
                                                }
                                            </button>
                                        </div>
                                    </CustomTooltip>
                                }
                                {
                                    !this.props.IsAddRule && !this.props.IsAddTemplate &&
                                    < CustomTooltip title='Signature' placement='bottom'>
                                        <div className="my-auto">
                                            <button tabIndex={15} data-up-arrow-index={300} onClick={(e) => this.onClickSignature()}
                                                onMouseEnter={() => { this.setState({ onSignatureHover: true }) }}
                                                onMouseLeave={() => { this.setState({ onSignatureHover: false }) }}
                                            >
                                                {(this.state.onSignatureHover || this.state.showSign) ? <SignatureActiveIcon className={`c-pointer p-1`} /> : <ComposerSignatureIcon className={`c-pointer p-1`} />
                                                }
                                            </button>
                                        </div>
                                    </CustomTooltip>
                                }
                                {!this.props.IsAddRule && !this.props.IsAddTemplate && this.props.Aifeatures &&
                                    <CustomTooltip title='Falkon Ai' placement='bottom'>

                                        <div className='my-auto'>
                                            {this.state.aiFeaturesPopUp ?
                                                <RefineMessageComposerActiveicon className='px-1 c-pointer' onClick={() => { this.setState({ aiFeaturesPopUp: false, falkonAiMessage: "" }); this.handleResetAiFeatureSelection() }} />
                                                :
                                                <RefineMessageComposerDisableicon className='px-1 c-pointer' onClick={() => { this.setState({ aiFeaturesPopUp: true, falkonAiMessage: "" }); this.handleResetAiFeatureSelection() }} />
                                            }
                                        </div>

                                    </CustomTooltip>
                                }
                                <FormHelperText className={`h5 color-primary-danger mt-1 ${!this.props.IsMobileDevice && this.props.TemplateErrorMessage ? 'ml-31' : 'ml-9'}`}>
                                    {!!this.props.TemplateErrorMessage && <div>{this.props.TemplateErrorMessage}</div>}
                                </FormHelperText>
                            </div>
                        </div>
                    </div>
                    <div className={`${this.props.IsNewMessage ? `${this.props.IsMobileDevice ? "b-around-text-field-border-4" : "RichEditor-root-border"}  br-2 o-y-scroll d-flex ${!!this.state.mediaUrl ? "max-h-18 border-top h-6" : "max-h-11 border-top h-6"}` : this.props.IsMobileDevice ? "" : !!this.state.mediaUrl ? "max-h-18 border-top h-6" : "max-h-11 border-top h-6"} d-flex flex-direction`}>
                        <div className='d-flex o-hidden'>
                            <div className={`d-flex flex-direction w-fill py-1 ${!this.props.IsMobileDevice ? this.props.IsNewMessage ? "pl-2" : "pr-2 pl-3" : ""} ${this.props.IsMobileDevice ? this.props.IsNewMessage ? "" : !!this.state.mediaUrl ? "max-h-18 bg-color-secondary RichEditor-root-border br-4 ml-2 mb-2" : "max-h-11 bg-color-secondary RichEditor-root-border br-5 ml-2 mb-2" : "o-y-scroll h4-regular"}`}>
                                {/* {!!this.state.mediaUrl &&
                                <div className={"p-1 d-flex"}>
                                    {this.state.mediatype === MediaType.IMAGE_JPEG || this.state.mediatype === MediaType.IMAGE || this.state.mediatype === MediaType.IMAGE_GIF || this.state.mediatype === MediaType.IMAGE_PNG || this.state.mediatype === MediaType.IMAGE_TIFF || this.state.mediatype === MediaType.IMAGE_ARW || this.state.mediatype === MediaType.IMAGE_WEBP || this.state.mediatype === MediaType.VIDEO || this.state.mediatype === MediaType.AUDIO || this.state.mediatype === MediaType.AUDIO_MP3 || this.state.mediatype === MediaType.AUDIO_MPeg || this.state.mediatype === MediaType.VIDEO_MP4 ?
                                        <><CancelIcon className={"c-pointer c-pointer my-2 mx-1"}
                                            onClick={this.closeMedia} />
                                            {this.getComponent(this.state.mediatype)}
                                        </>
                                        : this.getComponent(this.state.mediatype)
                                    }
                                </div>} */}
                                <div className={`${this.props.IsMobileDevice && "o-y-scroll px-2 h4-regular"}`}>
                                    <Mentions
                                        id={this.props.IsNewMessage ? "insert-tag-new-mentions" : "insert-tag-mentions"}
                                        body={this.state.body}
                                        isTemplate={this.state.isTemplate}
                                        tags={[]}
                                        placeholder={"Write a message..."}
                                        emoji={this.state.emoji}
                                        openTags={this.state.openTags}
                                        tagTarget={this.tagRef?.current}
                                        onKeyDown={this.HandleKeyDown}
                                        closeTags={() => { }}
                                        onChange={this.onBodyChange}
                                        maxLength={960}
                                        IsMobileDevice={this.props.IsMobileDevice}
                                        deviceHeight={this.props.DeviceHeight}
                                        IsNewMessage={this.props.IsNewMessage}
                                        IsAddRule={this.props.IsAddRule}
                                        onBlur={this.HandleBlur}
                                        phoneNumbers={this.props.PhoneNumbers}
                                        RemoveFacebookTemplate={this.RemoveFacebookTemplate}
                                        FacebookTemplate={this.state.facebookTemplate}
                                        readOnly={(this.props?.ChannelType === ChannelType.FACEBOOK && this.state.showScheduleType && !!this.state.media) ? true : false}
                                        Media={this.state?.media}
                                    />
                                    {this.state.showSign && !this.props.IsAddRule && !this.props.IsAddTemplate &&
                                        <div>
                                            <Mentions
                                                id={this.props.IsNewMessage ? "insert-tag-new-mentions-signature" : "insert-tag-mentions-signature"}
                                                body={this.state.bodySign}
                                                tags={[]}
                                                emoji={""}
                                                placeholder={this.state.defaultSign}
                                                openTags={false}
                                                tagTarget={this.tagRef?.current}
                                                onKeyDown={this.HandleKeyDown}
                                                closeTags={() => { }}
                                                onChange={this.onSignatureChange}
                                                maxLength={30}
                                                IsAddRule={this.props.IsAddRule}
                                                IsGroupChat={this.props.IsGroupChat || !!this.props.GroupChat?.ID}
                                            />
                                        </div>
                                    }
                                </div>
                                {this.props.IsMobileDevice && <div className={` d-flex live-chat-media ${!!this.state.mediaUrl && (this.props.IsMobileDevice ? "w-p-90 min-h-4 pt-1" : "w-p-30 min-h-5 pt-1 pb-1 ml-3 min-w-30")} pl-2`}>
                                    <div className="h-p-100 w-p-100 d-flex bg-color-live-chat-media-background br-4 mx-auto">
                                        <div className="w-p-15  d-flex align-center">
                                            <div className="o-hidden br-p-50 ml-1" style={{ width: this.props.IsMobileDevice ? "24px" : "28px", height: this.props.IsMobileDevice ? "24px" : "28px" }}>
                                                {this.getComponent(this.state.mediatype)}
                                            </div>
                                        </div>
                                        <div className={`w-p-70 d-flex align-center h5-medium color-live-chat-anonymous px-1 w-space`}>
                                            {!!this.state.mediaName && this.state.mediaName.slice(0, 21) + (this.state.mediaName.length > 21 ? "..." : ".")}
                                        </div>
                                        <div className="w-p-13 d-flex justify-center align-center ">
                                            <LiveChatMediaCancelIcon
                                                className={"c-pointer "}
                                                onClick={this.closeMedia}
                                            />
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            {
                                ((!this.props.IsNewMessage && this.props.IsMobileDevice) || (!this.props.IsAddRule && (!this.props.IsAddTemplate && !this.props.IsMobileDevice))) &&
                                <div className={`${(this.props.IsNewMessage) ? '' : this.props.IsMobileDevice ? 'my-auto mb-2 mx-1' : "my-auto mx-1"}`}>
                                    {
                                        (!this.props.IsMobileDevice) ?
                                            this.IsMessageValid() ? <ComposerSendActiveIcon className='p-1 c-pointer' onClick={() => this.sendMessage()} /> : <ComposerSendInActiveIcon className='p-1' />
                                            :
                                            <ButtonComponent
                                                buttonProps={{ tabIndex: 12 }}
                                                Loading={this.state.sendingNewMessage}
                                                HideLoader={!this.props.IsNewMessage}
                                                IsNewMessage={this.props.IsNewMessage}
                                                Variant={!this.IsMessageValid() ? (!this.props.IsNewMessage ? "disabled-btn" : "disabled-btn-small") : (!this.props.IsNewMessage ? "primary-btn" : "primary-btn-small")}
                                                Type={"submit"} OnClick={() => { this.sendMessage() }}
                                                ClassName={`c-pointer ${this.props.IsNewMessage
                                                    ? "p-absolute b-2 r-15" : !this.IsMessageValid() ? `px-2 py-1 send-btn-circle m-0 ${!this.props.IsMobileDevice && "ml-1"}` : `send-btn-circle px-2 py-1 m-0 ${!this.props.IsMobileDevice && "ml-1"}`}  ${!this.props.IsNewMessage && "justify-center pl-1"}`}
                                                ButtonLabel={(this.props.IsNewMessage && this.state.showScheduleType) ? "Schedule" : this.props.IsNewMessage ? this.state.ScheduleDateTime === -1 ? "Send" : "Schedule" : ""} Icon={this.props.IsNewMessage ? SendNewMsgIcon : SendWhiteIcon}
                                                IconToolTip={appNote.MESSAGE_SEND_TOOL_TIP} />
                                    }

                                    {!this.props.IsNewMessage || !this.props.IsAddRule &&
                                        <ButtonComponent
                                            buttonProps={{}}
                                            Variant="secondary-btn-small"
                                            ClassName={"p-absolute b-2 r-2"}
                                            OnClick={() => this.props.HandleClose && this.props.HandleClose()}
                                            ButtonLabel={buttonLabels.CANCEL}
                                        />
                                    }
                                </div>
                            }
                        </div>
                        {
                            !this.props.IsMobileDevice && <div className={` d-flex live-chat-media ${!!this.state.mediaUrl && (this.props.IsMobileDevice ? "w-p-72 h-4 pt-1" : "w-p-30 min-h-5 pt-1 pb-1 ml-3 min-w-30")} `}>
                                <div className="h-p-90 w-p-100 d-flex bg-color-live-chat-media-background br-4 mx-auto">
                                    <div className="w-p-15  d-flex align-center">
                                        <div className="o-hidden br-p-50 ml-1" style={{ width: "28px", height: "28px" }}>
                                            {this.getComponent(this.state.mediatype)}
                                        </div>
                                    </div>
                                    <div className={`w-p-70 d-flex align-center h5-medium color-live-chat-anonymous px-1 w-space`}>
                                        {!!this.state.mediaName && this.state.mediaName.slice(0, 21) + (this.state.mediaName.length > 21 ? "..." : ".")}
                                    </div>
                                    <div className="w-p-13 d-flex justify-center align-center ">
                                        <LiveChatMediaCancelIcon
                                            className={"c-pointer "}
                                            onClick={this.closeMedia}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {
                    (this.props.ChannelType === ChannelType.FACEBOOK || this.props.ChannelType === ChannelType.INSTAGRAM) &&
                    <div className={`${this.props.IsNewMessage && !this.props.IsMobileDevice && "mb-1 "} ${this.props.IsMobileDevice ? "ml-1" : ""} ml-1`}>
                        <div className={`color-con-hist-msg-date h5-regular ${this.props.IsMobileDevice ? "" : "ml-1"}`}>
                            <div >Characters: {this.getMessageLength()}/1999</div>
                        </div>
                    </div>
                }
                {
                    Boolean(this.state.anchorEmjoi) &&
                    <Popover
                        open={Boolean(this.state.anchorEmjoi)}
                        anchorEl={this.state.anchorEmjoi}
                        onClose={() => this.setState({ anchorEmjoi: null })}
                        anchorOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                            vertical: 'bottom',
                            horizontal: 'right',
                        } : {
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                            vertical: 'top',
                            horizontal: 'center',
                        } : {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                    >
                        <Emojis handleEmojiSelect={this.handleEmojiSelect} />
                    </Popover>
                }
                {
                    (!this.props.IsMobileDevice || !this.props.IsNewMessage || this.props.IsNewMessage) && Boolean(this.state.anchorTemplate) &&
                    <Popover open={Boolean(this.state.anchorTemplate)}
                        anchorEl={this.state.anchorTemplate}
                        onClose={this.onCloseshowTemplates}
                        style={this.props.IsMobileDevice && window.innerHeight !== this.props.DeviceHeight
                            && (UtilityService.isAndroid(navigator.userAgent) || UtilityService.isIPhone(navigator.userAgent)) ? {
                            top: this.props.DeviceHeight - 400,
                        } : {}}
                        anchorOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                            vertical: 'bottom',
                            horizontal: 'center',
                        } : {
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                            vertical: 'top',
                            horizontal: 'center',
                        } : {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        classes={{ paper: `${this.props.IsMobileDevice ? "" : "w-p-20"}` }}
                    >
                        <div className='h-v-40 d-flex flex-direction o-hidden p-1'>
                            <div className={` color-display-title d-flex justify-around `} id="customized-dialog-title">
                                <div className=' h4-semibold mr-auto color-template-title'>Templates</div><div>
                                    <Link to={AppRoutes.TEMPLATES}>
                                        <div className=' h5-regular ml-auto color-template-link t-decoration-underline float-right'>Go to templates</div>
                                    </Link>
                                </div>
                            </div>
                            <div
                                className={`px-1 my-1`}>
                                <TextField
                                    inputProps={{
                                        tabIndex: 4,
                                        "data-arrow-index": 200,
                                    }}
                                    fullWidth
                                    placeholder={"Find a Template..."}
                                    onChange={this.searchTemplates}
                                    variant="outlined"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIconSec />
                                            </InputAdornment>
                                        ),
                                        classes: {
                                            input: "h5-regular color-text-field-font",
                                            notchedOutline: "br-8",
                                        },
                                    }}
                                    size="small"
                                />
                            </div>

                            {(this.props.ChannelType === ChannelType.LIVE_CHAT || this.props.ChannelType === ChannelType.GOOGLE_BUSINESS) ?
                                <div className='o-y-auto o-x-hidden'>
                                    {fliterChannelTemplates?.map((template) =>
                                        <div className='mb-1 c-pointer grid-row p-1'
                                            onClick={() => {
                                                this.handleChannelTemplateClick(template); this.onCloseshowTemplates()
                                            }}>
                                            <div className='h5-semibold'>
                                                {template.Title}
                                            </div>
                                            <div className='d-flex bg-color-template-background  h5-regular p-1 payment-status-word'>
                                                <Mentions body={this.trimMessage(template.Message, 40)} tags={[]} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={template.Message?.length} id={''} placeholder={''} readOnly={true} />
                                                <div className='ml-auto my-auto pl-1'>{!!template.MediaType ? this.getTemplateMediaIcon(template.MediaType) : " "}</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                :
                                <div className='o-y-auto o-x-hidden'>
                                    {filterFacebookTemplates?.filter(x => x.TemplateType === "button").length === 0 ? "" : <div className='h5-semibold color-template-link px-1'>Button</div>}
                                    {filterFacebookTemplates?.filter(x => x.TemplateType === "button").map((template) =>
                                        <div className='mb-1 c-pointer grid-row p-1' onClick={() => { this.handleChannelTemplateClick(template); this.onCloseshowTemplates() }}>
                                            <div className='d-flex bg-color-template-background  h5-regular p-1 payment-status-word'>
                                                {template.Title}
                                            </div>
                                        </div>
                                    )}

                                    {filterFacebookTemplates?.filter(x => x.TemplateType === "media").length === 0 ? "" :
                                        <div className='h5-semibold color-template-link px-1'>Media</div>}
                                    {filterFacebookTemplates?.filter(x => x.TemplateType === "media").map((template) =>
                                        <div className='mb-1 c-pointer grid-row p-1' onClick={() => { this.handleChannelTemplateClick(template); this.onCloseshowTemplates() }}>
                                            <div className='d-flex bg-color-template-background  h5-regular p-1 payment-status-word'>
                                                {template.Title}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                    </Popover>
                }

            </div >
        )
    }
}

const mapStateToProps = (state: AppState): IStateProps => {
    return {
        IsMobileDevice: state.IsMobileDevice,
        DeviceHeight: state.DeviceHeight,
        Templates: state.Templates,
        Channels: state.Channels,
        FacebookTemplates: state.FacebookTemplates,
        ChannelTemplates: state.ChannelTemplates,
        ActiveChannelsTypes: state.ActiveChannelsTypes,
        PlanDetails: state.PlanDetails,
        Aifeatures: state.AiFeaturesOrgLevel,
    }
}

export default connect(mapStateToProps)(MessageComposer);